import React from 'react';
import PropTypes from 'prop-types';
import { sanitize } from '../../services/sanitize';
import EditableLabelAndInput from '../common/editable_label_and_input';

const ContentEditableFieldShoppingList = ({
  shoppingList,
  currentlyEditingInline,
  section,
  placeholderText,
  onInlineEditFocus,
  onInlineEditChange,
  onInlineEditBlur,
}) => {
  const isUnderEdit = currentlyEditingInline?.section === section;
  let contentEditableHtml = shoppingList[section];
  if (typeof contentEditableHtml === 'number') {
    contentEditableHtml = contentEditableHtml.toString();
  }
  if (typeof contentEditableHtml !== 'string') {
    contentEditableHtml = '';
  }

  // const onInlineEditKeyDown = (event) => {
  //   /*
  //     Pressing Enter or Esc in an inline edit field saves the changes.
  //    */
  //   if (event.keyCode === 13) {
  //     if (event.shiftKey) {
  //       console.log(`Shift-Enter pressed, value ${event.target.value}`);
  //       // let event bubble?
  //       return true;
  //     }
  //     event.target.blur();
  //   }
  //   if (event.keyCode === 27) {
  //     event.target.blur();
  //   }
  //   return null;
  // };

  return (
    <EditableLabelAndInput
      edit={isUnderEdit}
      defaultValue={contentEditableHtml}
      labelPlaceholder={placeholderText}
      disabled={false}
      inputStyle={{
        width: '100%',
      }}
      onFocus={() => onInlineEditFocus(section, null)}
      onChange={(value) => {
        const sanitized = sanitize(value);
        onInlineEditChange(section, null, sanitized);
      }}
      onDismiss={(reason) => onInlineEditBlur(section, null, reason)}
    />
  );
};

ContentEditableFieldShoppingList.propTypes = {
  section: PropTypes.string.isRequired,
  placeholderText: PropTypes.string,
  currentlyEditingInline: PropTypes.shape({
    section: PropTypes.string.isRequired,
    itemId: PropTypes.string,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  shoppingList: PropTypes.object.isRequired,
  onInlineEditFocus: PropTypes.func.isRequired,
  onInlineEditChange: PropTypes.func.isRequired,
  onInlineEditBlur: PropTypes.func.isRequired,
};

ContentEditableFieldShoppingList.defaultProps = {
  placeholderText: null,
};

export default ContentEditableFieldShoppingList;
